interface IDeliveryBarProps {
  children: React.ReactNode[];
  onClick?: () => void;
  disabled?: boolean;
  UNSAFE_className?: string;
}

const DeliveryBar: React.FC<IDeliveryBarProps> = ({
  children,
  onClick,
  disabled = false,
  UNSAFE_className = '',
}) => {
  const commonStyle = `${UNSAFE_className} tw-px-4 tw-pt-2 tw-pb-[10px] tw-flex tw-items-center tw-rounded-full tw-bg-blue-100 disabled:tw-cursor-default`;

  if (
    !children.find(
      (child) =>
        (child as React.ReactElement<any, React.FunctionComponent>).type
          .name === 'Container',
    )
  ) {
    return (
      <button
        data-testid="delivery-bar"
        onClick={onClick}
        disabled={disabled}
        className={`${commonStyle} tw-lf-button-clear [&_svg]:!tw-h-4 [&_svg]:!tw-w-4 [&_svg]:desktop:!tw-h-6 [&_svg]:desktop:!tw-w-6`}
      >
        {children}
      </button>
    );
  }

  return (
    <div
      className={`${commonStyle} tw-text-center desktop:tw-text-left [&_.picto]:tw-hidden [&_.picto]:desktop:tw-flex`}
    >
      {children}
    </div>
  );
};

export default DeliveryBar;
